<template>
  <div>
    <pm-page-title title="サインアップ"></pm-page-title>
    <section class="section">
      <form class="container">
        <!-- メールアドレスの入力欄としてテキストフィールドコンポーネントを使用 -->
        <pm-text-field
          type="email"
          placeholder="メールアドレス"
          icon="envelope"
          v-model="email"
        ></pm-text-field>
        <!-- パスワードの入力欄としてテキストフィールドコンポーネントを使用 -->
        <pm-text-field
          type="password"
          placeholder="パスワード"
          icon="lock"
          v-model="password"
        ></pm-text-field>
        <div class="field">
          <p class="control">
            <button class="button is-primary" @click.prevent="signUp">
              サインアップ
            </button>
          </p>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import pmPageTitle from "@/components/PageTitle";
// テキストフィールドコンポーネントをインポート
import pmTextField from "@/components/TextField";
import { authService } from "@/services/AuthService";
import { userService } from "@/services/UserService";

export default {
  name: "sign_up",
  components: { pmPageTitle, pmTextField },
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    signUp() {
      // 直接呼び出していた部分をサービスクラス経由に変更
      authService
        .signUp(this.email, this.password)
        .then(credential => {
          return userService.createUser(credential.user);
        })
        .then(() => {
          this.$router.push({ name: "home" });
        })
        .catch(error => {
          alert(error.message);
        });
    }
  }
};
</script>
